import { isString } from 'lodash-es';

import {
  HoneycombTileCategoricalData,
  HoneycombTileData,
} from '../types/honeycomb.js';

export const isHoneycombTileCategoricalData = (
  data: HoneycombTileData,
): data is HoneycombTileCategoricalData => isString(data.value);
